
import React from 'react';
import { Link } from 'react-router-dom';

const Categories = () => {
  return (
    <>
      {/* Page Header */}
      <section className="relative py-20 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1920&q=80')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content */}
        <div className="relative container mx-auto px-4 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Job Categories</h1>
          <div className="flex items-center justify-center space-x-2 text-lg">
            <Link to="/" className="hover:text-blue-300 transition-colors">Home</Link>
            <i className="fas fa-chevron-right text-sm"></i>
            <span className="text-blue-300">Categories</span>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Browse Jobs by Category</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Find the perfect job in your preferred industry or profession</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {/* Category 1 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-laptop-code text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">IT & Software</h3>
              <p className="text-gray-600 mb-4">1,245+ Jobs Available</p>
              <Link to="/jobs?category=it" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 2 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-chart-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Accounting & Finance</h3>
              <p className="text-gray-600 mb-4">876+ Jobs Available</p>
              <Link to="/jobs?category=finance" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 3 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-hotel text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hospitality & Tourism</h3>
              <p className="text-gray-600 mb-4">1,120+ Jobs Available</p>
              <Link to="/jobs?category=hospitality" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 4 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-stethoscope text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Healthcare & Medical</h3>
              <p className="text-gray-600 mb-4">950+ Jobs Available</p>
              <Link to="/jobs?category=healthcare" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 5 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-bullhorn text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Marketing & PR</h3>
              <p className="text-gray-600 mb-4">780+ Jobs Available</p>
              <Link to="/jobs?category=marketing" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 6 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-shopping-bag text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Retail & Sales</h3>
              <p className="text-gray-600 mb-4">1,350+ Jobs Available</p>
              <Link to="/jobs?category=retail" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 7 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-truck text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Transportation & Logistics</h3>
              <p className="text-gray-600 mb-4">650+ Jobs Available</p>
              <Link to="/jobs?category=logistics" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 8 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-hard-hat text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Construction & Engineering</h3>
              <p className="text-gray-600 mb-4">920+ Jobs Available</p>
              <Link to="/jobs?category=construction" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 9 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-graduation-cap text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Education & Teaching</h3>
              <p className="text-gray-600 mb-4">580+ Jobs Available</p>
              <Link to="/jobs?category=education" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 10 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-gavel text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Legal & Law</h3>
              <p className="text-gray-600 mb-4">320+ Jobs Available</p>
              <Link to="/jobs?category=legal" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 11 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-plane text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Aviation & Airlines</h3>
              <p className="text-gray-600 mb-4">450+ Jobs Available</p>
              <Link to="/jobs?category=aviation" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 12 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-oil-can text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Oil & Gas</h3>
              <p className="text-gray-600 mb-4">380+ Jobs Available</p>
              <Link to="/jobs?category=oil-gas" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 13 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-users text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Human Resources</h3>
              <p className="text-gray-600 mb-4">420+ Jobs Available</p>
              <Link to="/jobs?category=hr" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 14 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-palette text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Design & Creative</h3>
              <p className="text-gray-600 mb-4">510+ Jobs Available</p>
              <Link to="/jobs?category=design" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 15 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-headset text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Customer Service</h3>
              <p className="text-gray-600 mb-4">890+ Jobs Available</p>
              <Link to="/jobs?category=customer-service" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>

            {/* Category 16 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center group hover:bg-blue-50">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors">
                <i className="fas fa-university text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Banking & Finance</h3>
              <p className="text-gray-600 mb-4">760+ Jobs Available</p>
              <Link to="/jobs?category=banking" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors">
                Browse Jobs <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Searches Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Popular Job Searches</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Discover trending job searches in Dubai and UAE</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/jobs?keyword=software+developer" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Software Developer</Link>
            <Link to="/jobs?keyword=accountant" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Accountant</Link>
            <Link to="/jobs?keyword=nurse" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Nurse</Link>
            <Link to="/jobs?keyword=sales+executive" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Sales Executive</Link>
            <Link to="/jobs?keyword=project+manager" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Project Manager</Link>
            <Link to="/jobs?keyword=receptionist" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Receptionist</Link>
            <Link to="/jobs?keyword=chef" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Chef</Link>
            <Link to="/jobs?keyword=driver" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Driver</Link>
            <Link to="/jobs?keyword=teacher" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Teacher</Link>
            <Link to="/jobs?keyword=marketing+specialist" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Marketing Specialist</Link>
            <Link to="/jobs?keyword=hr+manager" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">HR Manager</Link>
            <Link to="/jobs?keyword=civil+engineer" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Civil Engineer</Link>
            <Link to="/jobs?keyword=graphic+designer" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Graphic Designer</Link>
            <Link to="/jobs?keyword=security+guard" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Security Guard</Link>
            <Link to="/jobs?keyword=administrative+assistant" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Administrative Assistant</Link>
            <Link to="/jobs?keyword=customer+service" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Customer Service</Link>
            <Link to="/jobs?keyword=warehouse+worker" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Warehouse Worker</Link>
            <Link to="/jobs?keyword=flight+attendant" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Flight Attendant</Link>
            <Link to="/jobs?keyword=bank+teller" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Bank Teller</Link>
            <Link to="/jobs?keyword=pharmacist" className="inline-block px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all duration-200 text-sm font-medium">Pharmacist</Link>
          </div>
        </div>
      </section>

      {/* Job Alert Section */}
      <section className="py-16 bg-blue-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Get Job Alerts in Your Email</h2>
              <p className="text-xl text-blue-100">Stay updated with the latest job opportunities matching your preferences</p>
            </div>
            <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Your email address"
                required
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent"
              />
              <button
                type="submit"
                className="px-8 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-200 whitespace-nowrap"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Categories;
